import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row",
  style: {"display":"inline !important"}
}
const _hoisted_3 = { style: {"display":"inline !important"} }
const _hoisted_4 = {
  key: 1,
  class: "row",
  style: {"display":"inline !important"}
}
const _hoisted_5 = { style: {"display":"inline !important"} }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_ctx.theModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel/*.sort((a, b) => (b.Descriptor == 1 ? -1 : b.Descriptor) - (a.Descriptor == 1 ? -1 : a.Descriptor))*/, (opts, oi) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "q-mb-xs",
            key: oi
          }, [
            (opts.Descriptor === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.$t('show_filtered_positions_only')) + "  ", 1),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_q_option_group, {
                      style: {"max-width":"fit-content","display":"inline !important"},
                      options: [ { value: true, label: _ctx.$t('yes') }, { value: false, label: _ctx.$t('no')} ],
                      type: "radio",
                      size: "20px",
                      inline: "",
                      modelValue: opts.Toggled,
                      "onUpdate:modelValue": ($event: any) => ((opts.Toggled) = $event)
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (opts.Descriptor === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t('show_original_selection_only')) + "  ", 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_option_group, {
                      style: {"max-width":"fit-content","display":"inline !important"},
                      options: [ { value: true, label: _ctx.$t('yes') }, { value: false, label: _ctx.$t('no')} ],
                      type: "radio",
                      size: "20px",
                      inline: "",
                      modelValue: opts.Toggled,
                      "onUpdate:modelValue": ($event: any) => ((opts.Toggled) = $event)
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (opts.Descriptor === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('what_to_show_sum_qty_columns')) + ":  ", 1),
                  _createVNode(_component_q_option_group, {
                    style: {"max-width":"fit-content","display":"inline !important"},
                    options: [ { value: 0, label: _ctx.$t('separate_per_position_default')+';' }, 
              { value: 1, label: _ctx.$t('sum_qty_shown_table')+';'}, 
              { value: 2, label: _ctx.$t('sum_qty_all_action')+';'}
            ],
                    type: "radio",
                    size: "20px",
                    modelValue: opts.DisplayKind,
                    "onUpdate:modelValue": ($event: any) => ((opts.DisplayKind) = $event)
                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}